{
  "RESET_PASSWORD": {
    "TITLE": "重置密码",
    "DESCRIPTION": "输入您用来登录到Chatwoot 的电子邮件地址，获取密码重置说明。",
    "GO_BACK_TO_LOGIN": "回到登录页面",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "请输入 Email 地址.",
      "ERROR": "请输入一个有效的电子邮件."
    },
    "API": {
      "SUCCESS_MESSAGE": "密码重置链接已发送到您的电子邮件.",
      "ERROR_MESSAGE": "无法连接 Woot 服务器，请稍后再试。"
    },
    "SUBMIT": "提交"
  }
}
